<template>
    <div :ref="stepName">
        <div class="form-header">
            <p>Pour accéder à tous les services, recevoir nos magazines et votre cadeau de bienvenue, remplissez les champs suivants&nbsp;:</p>
        </div>
        <AddressForm></AddressForm>
    </div>
</template>

<script>
import AddressForm from "./AddressForm";
import mixin from "../../../travel_step_mixin";
import animation_engine_mixin from "../../../animation_engine_mixin";
import animation_step_style_mixin from "../../../animation_step_style_mixin";

export default {
    components: { AddressForm },
    mixins: [mixin,  animation_engine_mixin, animation_step_style_mixin],
}
</script>
